import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { AppProviders } from './providers/AppProviders';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find root element');

ReactDOM.createRoot(rootElement).render(
    <BrowserRouter>
        <AppProviders>
            <App />
        </AppProviders>
    </BrowserRouter>
);
